/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_CompanyInputs */

const en_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const de_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

const fr_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const es_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

const it_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azienda`)
};

const nl_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijf`)
};

const pl_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

const fi_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritys`)
};

const da_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virksomhed`)
};

const sv_resume_editor_company = /** @type {(inputs: Resume_Editor_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foretag`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Resume_Editor_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_company = /** @type {((inputs?: Resume_Editor_CompanyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_CompanyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_company(inputs)
	if (locale === "fr") return fr_resume_editor_company(inputs)
	if (locale === "es") return es_resume_editor_company(inputs)
	if (locale === "it") return it_resume_editor_company(inputs)
	if (locale === "nl") return nl_resume_editor_company(inputs)
	if (locale === "pl") return pl_resume_editor_company(inputs)
	if (locale === "fi") return fi_resume_editor_company(inputs)
	if (locale === "da") return da_resume_editor_company(inputs)
	if (locale === "sv") return sv_resume_editor_company(inputs)
	return en_resume_editor_company(inputs)
});